export class CostCenter {
    name: string;

    constructor(options: any) {
        this.name = options && options.name ? options.name : '';
    }
}

export default CostCenter;
